import api from "@/apis/merchanttransactioncontrol/ReportControlAPI";
import Crud from "../crud-base";
var crud = new Crud("merchanttransactioncontrolreports", api);

const state = {
  ...crud.state,
  //...stateOverride,
  _config: {
    field: {},
  },

  //   overview: {
  //     totalJetpaypayToMerchant: 0, // tổng tiền thanh toán
  //     totalJetPayPaid: 0, // tổng tiền đã thanh toán
  //   },
};
const getters = {
  ...crud.getters,
  //...gettersOverride
};
const actions = {
  ...crud.actions,
  //...actionsOverride,
  /**
   * Load danh sách
   */
  async load(context, payload) {
    let res = null;
    try {
      context.commit("updateLoading", true);
      res = await api.getList(payload || {});
    } finally {
      context.commit("updateLoading", false);
    }
    if (res) {
      if (res.items.length > 0) {
        res.customData.totalQuantityTransHold =
          res.items[res.items.length - 1].totalQuantityTransHold;
        res.customData.totalAmountTransHold = res.items[res.items.length - 1].totalAmountTransHold;
      }
      context.commit("setSummary", res.customData);
      context.commit("setItems", { result: res, payload: payload });
    }

    return res;
  },
};
const mutations = {
  ...crud.mutations,
  //   setOverviewData(state, data) {
  //     state.overview = { ...state.overview, ...data };
  //     state.summary = { ...state.summary, ...data };
  //   },
};

export default {
  debug: import.meta.env.PROD,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
